const PACK_TAG_KEY = "admin.jigsaw.pack.tagById";

function readMap() {
    try {
        const parsed = JSON.parse(localStorage.getItem(PACK_TAG_KEY) || "{}");
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
}

export function readPackTag(packId) {
    if (!packId) return "";
    const tag = readMap()[packId];
    return typeof tag === "string" ? tag.trim() : "";
}

export function writePackTag(packId, tag) {
    if (!packId) return;
    const next = String(tag || "").trim();
    if (!next) return;
    try {
        const map = readMap();
        map[packId] = next;
        localStorage.setItem(PACK_TAG_KEY, JSON.stringify(map));
    } catch {
    }
}
